/**
 * Vertical Banner Slider — Ethnc-style stacked slides
 * - next banner slides up over the current one
 * - mouse wheel, swipe and arrow keys
 * - plays only the visible video
 * - tells the header which colour to use for each slide
 */
(function () {
  'use strict';

  var SPEED = 1000;

  function setHeaderColor(swiper) {
    var slide = swiper.slides[swiper.activeIndex];
    var color = slide && slide.getAttribute('data-header-color');
    if (!color) return;
    window.__rayHeaderColor = color;
    document.dispatchEvent(new CustomEvent('ray:header-color', { detail: { color: color } }));
  }

  function eachVideo(slide, fn) {
    if (!slide) return;
    slide.querySelectorAll('video').forEach(fn);
  }

  function playActive(swiper) {
    var active = swiper.slides[swiper.activeIndex];
    eachVideo(active, function (v) {
      if (v.offsetParent === null) return; // hidden desktop/mobile copy
      v.muted = true;
      v.preload = 'auto';
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
    // warm up the next banner's video
    eachVideo(swiper.slides[swiper.activeIndex + 1], function (v) {
      if (v.offsetParent !== null) v.preload = 'auto';
    });
  }

  function pauseInactive(swiper) {
    swiper.slides.forEach(function (slide, i) {
      if (i === swiper.activeIndex) return;
      eachVideo(slide, function (v) { v.pause(); });
    });
  }

  function init(el) {
    if (!el || typeof Swiper === 'undefined') return;
    if (el.__vbs) { el.__vbs.destroy(true, true); el.__vbs = null; }

    var swiperEl = el.querySelector('.vbs__swiper');
    if (!swiperEl) return;

    var autoplayMs = parseInt(el.getAttribute('data-autoplay'), 10) || 0;
    if (window.Shopify && Shopify.designMode) autoplayMs = 0;
    var hasFooter = !!el.querySelector('.vbs-slide--footer');
    var timer = null;

    function schedule(sw) {
      clearTimeout(timer);
      if (!autoplayMs || document.hidden) return;
      var slide = sw.slides[sw.activeIndex];
      if (!slide || slide.classList.contains('vbs-slide--footer')) return;
      timer = setTimeout(function () {
        var lastBanner = sw.slides.length - (hasFooter ? 2 : 1);
        if (sw.activeIndex >= lastBanner) sw.slideTo(0, SPEED);
        else sw.slideNext(SPEED);
      }, autoplayMs);
    }

    var swiper = new Swiper(swiperEl, {
      direction: 'vertical',
      slidesPerView: 1,
      speed: SPEED,
      effect: 'creative',
      creativeEffect: {
        prev: { translate: [0, '-0%', -1] },
        next: { translate: [0, '100%', 0] }
      },
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        thresholdDelta: 25,
        releaseOnEdges: true
      },
      keyboard: { enabled: true, onlyInViewport: true },
      allowTouchMove: true,
      watchSlidesProgress: true,
      on: {
        init: function (sw) {
          setHeaderColor(sw);
          playActive(sw);
          schedule(sw);
        },
        slideChangeTransitionStart: function (sw) {
          playActive(sw);
          setTimeout(function () { setHeaderColor(sw); }, SPEED * 0.35);
        },
        slideChangeTransitionEnd: function (sw) {
          pauseInactive(sw);
          schedule(sw);
        }
      }
    });

    el.__vbs = swiper;

    // Restart the timer when the tab becomes visible again
    document.addEventListener('visibilitychange', function () { schedule(swiper); });

    // After a newsletter signup the page reloads: jump back to the footer slide
    var nid = el.getAttribute('data-newsletter-id');
    if (hasFooter && (/customer_posted=true/.test(location.search) || (nid && location.hash.indexOf(nid) > -1))) {
      swiper.slideTo(swiper.slides.length - 1, 0);
    }
  }

  function initAll() {
    document.querySelectorAll('.vbs').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('.vbs'));
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('.vbs');
    if (el && el.__vbs) { el.__vbs.destroy(true, true); el.__vbs = null; }
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('.vbs-slide');
    var el = e.target.closest('.vbs');
    if (!slide || !el || !el.__vbs) return;
    var idx = Array.prototype.indexOf.call(el.__vbs.slides, slide);
    if (idx > -1) el.__vbs.slideTo(idx, 0);
  });
})();
